import { skipToken } from '@reduxjs/toolkit/query';
import { useGetPickUpByIdQuery } from '../../Shippings/services/visits.service';
import { PickUpVisit } from '../models';

interface UsePickUpDetailProps {
  id?: string;
  skip?: boolean;
}

const usePickUpDetail = ({ id, skip = false }: UsePickUpDetailProps) => {
  const { data, isLoading, error } = useGetPickUpByIdQuery(
    skip || !id ? skipToken : { id }
  );

  return {
    pickUp: data as unknown as PickUpVisit | undefined,
    isLoading,
    error,
  };
};

export default usePickUpDetail;
